import { Component, OnInit } from '@angular/core';
import { GetPromptService } from '../../services/get-prompts/get-prompts.service';
import { DeletePromptService } from '../../services/delete-prompt/delete-prompts.service';
import { AvaliacoesPromptService } from '../../services/avaliacoes-prompt/avaliacoes-prompt.service';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { MessageNotificationService } from '../../services/message-notification.service';
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from '../../constants/validation-messages';
import { handleHttpError } from '../../utils/error-handler.util';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-meu-painel',
  templateUrl: './meu-painel.component.html',
  styleUrls: ['./meu-painel.component.css'],
  standalone: false,
})
export class MeuPainelComponent implements OnInit {
  prompts: any[] = [];
  userName: string = '';

  constructor(
    private apiService: GetPromptService,
    private deletePromptService: DeletePromptService,
    private avaliacoesPromptService: AvaliacoesPromptService,
    private router: Router,
    private keycloakService: KeycloakService,
    private messageNotificationService: MessageNotificationService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    if (this.keycloakService.isLoggedIn()) {
      this.keycloakService
        .loadUserProfile()
        .then((profile) => {
          this.userName = profile.firstName
            ? profile.firstName
            : profile.username;
          this.carregarPrompts();
        })
        .catch((err) => {
          console.error('Erro ao carregar perfil do usuário:', err);
        });
    }
  }

  carregarPrompts(): void {
    this.apiService.getPromptsByUser().subscribe({
      next: (response) => {
        this.prompts = response.data.map((prompt: any) => ({
          id: prompt.prompt_id,
          titulo: prompt.prompt_titulo,
          data: new Date(prompt.prompt_dtCriacao),
          rating: 0, // Inicialmente 0 até calcular a média
        }));

        this.prompts.forEach((prompt) => this.calcularMediaAvaliacoes(prompt));
      },
      error: (error: any) => {
        console.error('Erro ao carregar os prompts:', error);
        const errorMessage = handleHttpError(error);
        this.messageNotificationService.showError(
          ERROR_MESSAGES.LOAD_FAILED + ' ' + errorMessage
        );
      },
    });
  }

  calcularMediaAvaliacoes(prompt: any): void {
    this.avaliacoesPromptService.getAvaliacoesPorPrompt(prompt.id).subscribe({
      next: (res) => {
        const avaliacoes = res.data || [];
        if (avaliacoes.length > 0) {
          const somaAvaliacoes = avaliacoes.reduce(
            (sum: number, av: any) => sum + av.avaliacao_valor,
            0
          );
          prompt.rating = Math.round(somaAvaliacoes / avaliacoes.length);
        } else {
          prompt.rating = 0; // Sem avaliações
        }
      },
      error: (err) => {
        console.error(
          `Erro ao carregar avaliações para o prompt ${prompt.id}:`,
          err
        );
      },
    });
  }

  deletarPrompt(prompt: any): void {
    this.confirmationService.confirm({
      message: `Você realmente deseja deletar o prompt "${prompt.titulo}"?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.deletePromptService.deletarPrompt(prompt.id).subscribe({
          next: () => {
            this.prompts = this.prompts.filter((p) => p.id !== prompt.id);
            this.messageNotificationService.showSuccess(
              SUCCESS_MESSAGES.PROMPT_DELETED
            );
          },
          error: (err) => {
            console.error('Erro ao deletar o prompt:', err);
            const errorMessage = handleHttpError(err);
            this.messageNotificationService.showError(
              ERROR_MESSAGES.DELETE_FAILED + ' ' + errorMessage
            );
          },
        });
      }
    });
  }

  duplicarPrompt(prompt: any) {
    if (!prompt || !prompt.id) {
      console.error('Erro: Prompt inválido.');
      return;
    }
    localStorage.setItem('duplicatedPromptId', String(prompt.id));
    this.router.navigate(['/cadastro-prompt']);
  }

  visualizarPrompt(promptId: number): void {
    this.router.navigate([`/tela-prompt/${promptId}`]);
  }
}
